import {
    Heading,
    Stack,
    ThemeFontSizeVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import { useTranslation } from "react-i18next";
import EmailField from "components/details-form/email-field";
import NameField from "components/details-form/name-field";
import { PhoneField } from "components/details-form/phone-field";
import { useStepTracking } from "logger/use-step-tracking";
import { TrackingStepName } from "logger/user-tracking";
import { Control, UseFormTrigger } from "react-hook-form";
import { ContactInfoForm } from "store/store-types";
import { Contact } from "types/contact";

interface EditContactViewProps {
    contact: Contact;
    control: Control<ContactInfoForm>;
    trigger: UseFormTrigger<ContactInfoForm>;
}

const EditContactView = ({ contact, control, trigger }: EditContactViewProps) => {
    const { t } = useTranslation();

    useStepTracking({
        stepName: TrackingStepName.EditBookingContact,
    });

    return (
        <Stack spacing={ThemeSpaceVariable.Medium}>
            <Heading as="h3" fontSize={ThemeFontSizeVariable.XLarge}>
                {t("editBooking.editContactDetails")}
            </Heading>
            <Stack direction={{ base: "column", md: "row" }} gap={ThemeSpaceVariable.Medium}>
                <NameField
                    value={contact.fname || ""}
                    control={control}
                    variant="fname"
                    trigger={trigger}
                />
                <NameField
                    value={contact.lname || ""}
                    control={control}
                    variant="lname"
                    trigger={trigger}
                />
            </Stack>
            <PhoneField value={contact.mobile || ""} control={control} trigger={trigger} />
            <EmailField value={contact.email || ""} control={control} trigger={trigger} />
        </Stack>
    );
};

export default EditContactView;
